import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Box, Heading, Flex } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { menuOpsAdmin, verificationMenuOpsClient, IMenuItem } from './cards';
import { CardButton } from './components/CardButton';
import { checkPermission } from 'utils/authentication';
import useEventBus from 'hooks/useEventBus';
import { getUserData } from 'services/getUserData';
import { getLoggedUser } from 'utils/storage';
import { Loading } from 'components';

interface IRolesStorage {
  authority: string;
}

export const Home: React.FC = () => {
  const [menuClientOptions, setMenuClientOptions] = useState<IMenuItem[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [typeUser, setTypeUser] = useState<string | number | boolean>('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [userRolesLogged, setUserRolesLogged] = useState<any>([]);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const path = history.location.pathname;
  localStorage.setItem('goBack', path);

  const eventBus = useEventBus();
  useEffect(() => {
    eventBus.dispatchEvent('onChangeTitle', '');
  }, []);

  const handleGetDataUserLogged = async () => {
    const idLogged = getLoggedUser().id;

    const roles: IRolesStorage[] = JSON.parse(localStorage.getItem('@dpohub/roles') || '');

    if (roles.length === 0) {
      setUserRolesLogged(roles);
    }

    try {
      const userLogged = await getUserData(String(idLogged));
      const dataUserLogged = userLogged.data;
      setTypeUser(dataUserLogged.employeeDanielLaw);
    } catch {}
  };

  const getMenuClientOptins = async (id: string) => {
    try {
      setIsLoading(true);
      const data = await verificationMenuOpsClient(id);

      setMenuClientOptions(data);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useLayoutEffect(() => {
    handleGetDataUserLogged();
    const idLogged = getLoggedUser().id;
    getMenuClientOptins(String(idLogged));
  }, []);
  return (
    <Box w="100%" h="100%">
      <Heading as="div" color="brand.gray600" fontSize="20px" fontWeight="700" mb="8px">
        Bem-vindo ao DPO HUB!
      </Heading>
      <Heading
        mb="20px"
        as="div"
        color="brand.primary"
        fontSize="32px"
        fontWeight="700"
        isTruncated
      >
        O que você procura?
      </Heading>

      <Flex
        flexWrap="wrap"
        w="100%"
        h={checkPermission({ onlyClient: true }) && isLoading ? '78%' : ''}
      >
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            {menuOpsAdmin.map((op, id) => {
              return <CardButton key={id} {...op} id={id} />;
            })}
          </>
        ) : isLoading ? (
          <Flex w="100%" alignItems="center" justify="center">
            <Loading />
          </Flex>
        ) : (
          <>
            {menuClientOptions.map((op, id) => {
              return <CardButton key={id} {...op} id={id} />;
            })}
          </>
        )}
      </Flex>
    </Box>
  );
};
